import { render, staticRenderFns } from "./AttributeForm.vue?vue&type=template&id=37f86c45&scoped=true&"
import script from "./AttributeForm.vue?vue&type=script&lang=js&"
export * from "./AttributeForm.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/attribute/AttributeForm/AttributeFormStyle.css?vue&type=style&index=0&id=37f86c45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f86c45",
  null
  
)

export default component.exports